import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">
      <div className="text-center">
        {/* 404 Large Number */}
        <h1 className="text-9xl font-bold text-blue-600 mb-4">404</h1>

        {/* Error Message */}
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Seite nicht gefunden
        </h2>

        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
          Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.
        </p>

        {/* Phone Icon */}
        <div className="text-6xl mb-8">📱</div>

        {/* Action Buttons */}
        <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            Zur Startseite
          </Link>

          <Link
            to="/kontakt"
            className="inline-block px-6 py-3 border border-blue-600 text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-colors duration-200"
          >
            Kontakt aufnehmen
          </Link>
        </div>

        {/* Quick Links */}
        <div className="mt-12">
          <p className="text-gray-500 mb-4">Oder besuchen Sie eine unserer anderen Seiten:</p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/repair" className="text-blue-600 hover:text-blue-800 hover:underline">
              Reparatur-Services
            </Link>
            <Link to="/track" className="text-blue-600 hover:text-blue-800 hover:underline">
              Bestellung verfolgen
            </Link>
            <Link to="/impressum" className="text-blue-600 hover:text-blue-800 hover:underline">
              Impressum
            </Link>
            <Link to="/agb" className="text-blue-600 hover:text-blue-800 hover:underline">
              AGB
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}